import * as lvFlandersBarShared from '../dist/@lvflanders/bar';

// global glue variable for externals
if (window['lvflanders'] == null) window['lvflanders'] = <any>{};
if (window['lvflanders'].bar == null) window['lvflanders'].bar = <any>{};

window['lvflanders'].bar.shared = lvFlandersBarShared;

export { lvFlandersBarShared };
